export default {
  en: {
    error: 'Error',
    full: 'Text field is full',
    maxLengthLabel: _ref => {
      let {
        maxLength
      } = _ref;
      return "Enter at most " + maxLength + " character" + (maxLength === 1 ? '' : 's');
    }
  },
  fi: {
    error: 'Virhe',
    full: 'Tekstikenttä on täynnä',
    maxLengthLabel: _ref2 => {
      let {
        maxLength
      } = _ref2;
      return "Sy\xF6t\xE4 korkeintaan " + maxLength + " merkki" + (maxLength === 1 ? '' : 'ä');
    }
  },
  sv: {
    error: 'Fel',
    full: 'Textfältet är fullt',
    maxLengthLabel: _ref3 => {
      let {
        maxLength
      } = _ref3;
      return "Ange upp till " + maxLength + " tecken";
    }
  }
};